import axios from "axios";
import { API_URL } from "../../config";
import { getToken } from "../../utils/authManager";

export function _fetchUsers() {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://reqres.in/api/users`)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const _addChatedPerson = id => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}chat/${id}`, null,{
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const _getChatedPerson = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}chat/`, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const _getChats = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}chat/${id}`, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}